'use client';

import React from 'react';
import Link from '../components/SafeLink';

export default function HeroSection() {
    return (
        <section className="hero-bg relative flex flex-col items-center justify-center min-h-screen">
            <video
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                className="absolute top-0 left-0 w-full h-full object-cover z-0"
                onContextMenu={(e) => e.preventDefault()}
            >
                <source src="/videos/background.mp4" type="video/mp4" />
                <source src="/videos/background.webm" type="video/webm" />
                Ваш браузер не поддерживает видеофон.
            </video>

            <div className="text-center relative z-10 px-4 max-w-3xl">
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-snug sm:leading-tight md:leading-tight text-white">
                    КАДРОВОЕ АГЕНТСТВО<br />
                    НОВОГО ПОКОЛЕНИЯ «INTERIM»
                </h1>

                <Link
                    href="#our-directions"
                    className="mt-8 sm:mt-10 md:mt-12 inline-block bg-orange-500 text-blue-900 px-8 py-3 rounded-full hover:bg-orange-400 transition duration-300 font-bold"
                >
                    Узнать больше
                </Link>
            </div>
        </section>
    );
}
